module.exports = __webpack_public_path__ + "static/media/ES.8d4525d9.svg";